/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { resolveActionRequestApiV1ActionRequestsRequestIdResolvePost } from '../fn/action-requests/resolve-action-request-api-v-1-action-requests-request-id-resolve-post';
import { ResolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Params } from '../fn/action-requests/resolve-action-request-api-v-1-action-requests-request-id-resolve-post';
import { ActionRequestRead } from '../models/action-request-read';

@Injectable({ providedIn: 'root' })
export class ActionRequestsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resolveActionRequestApiV1ActionRequestsRequestIdResolvePost()` */
  static readonly ResolveActionRequestApiV1ActionRequestsRequestIdResolvePostPath = '/api/v1/action-requests/{request_id}/resolve';

  /**
   * Resolve Action Request.
   *
   * Resolve an action request with approval or denial
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resolveActionRequestApiV1ActionRequestsRequestIdResolvePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Response(params: ResolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ActionRequestRead>> {
    return resolveActionRequestApiV1ActionRequestsRequestIdResolvePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resolve Action Request.
   *
   * Resolve an action request with approval or denial
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveActionRequestApiV1ActionRequestsRequestIdResolvePost(params: ResolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Params, context?: HttpContext): Observable<ActionRequestRead> {
    return this.resolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActionRequestRead>): ActionRequestRead => r.body)
    );
  }

}
